// extracted by mini-css-extract-plugin
module.exports = {"component":"RiddleGame_component_3iPtb"};